<template>
  <div class="correct-details containter" :class="{ mobile_: isMobile }">
    <div class="content">
      <a-form-model :model="policyForm" :rules="policyRules">
        <!-- 头部信息组件 -->
        <correct-header :policy="policyForm.policy"></correct-header>
        <!-- 投保人信息组件 -->
        <policyHolder :batchHolder="policyForm.batchHolder" :holderCfg="holderCfg"></policyHolder>
        <!-- 被保人信息组件（移动端） -->
        <insured-mobile v-if="isMobile" :batchInsureList="policyForm.batchInsureList" :insuredCfg="insuredCfg" @changeInsured="changeInsured"></insured-mobile>
        <!-- 被保人信息组件（PC端） -->
        <insured ref="insured" v-else :batchInsureList="policyForm.batchInsureList" :insuredCfg="insuredCfg" @insuredSave="insuredSave" @delAddInsured="delAddInsured"></insured>
        <!-- 计划信息组件 -->
        <plan v-if="planCfg.isShow" :plan="policyForm.plan" :planCfg="planCfg"></plan>
        <!-- 附加信息组件 -->
        <additional :policyForm="policyForm" @uploadFile="uploadFile"></additional>
        <!-- 底部信息组件 -->
        <correct-footer :policyForm="policyForm" :showTips="showTips" @submit="submitForm"></correct-footer>
      </a-form-model>
    </div>
  </div>
</template>

<script>
import { commonMixin } from '@/views/correct/mixins/commonMixin.js';
import commonOptions from '../common/options'; // 公共数据源
export default {
  mixins: [commonMixin],
  data() {
    return {
      // 投保人配置项数据
      holderCfg: {
        // 自定义的投保人基础信息配置，若没有，则使用公共配置
        holderItems: [],
        // 数据源对象
        dataSourceObj: {}
      },
      // 被保人配置项数据
      insuredCfg: {
        // 被保人修改表单校验规则配置
        editRules: {
          batchDate: [{ required: true, message: '请选择批单生效日', trigger: 'change' }],
          name: [{ required: true, message: '请输入被保人姓名', trigger: 'blur' }],
          mobile: [{ required: false, message: '请输入正确的手机号', trigger: 'blur', pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/ }],
          idType: [{ required: true, message: '请选择证件类型', trigger: 'change' }],
          idNumber: [{ required: true, message: '请输入证件号码', trigger: 'blur' }],
          birthDate: [{ required: true, message: '请选择出生日期', trigger: 'change' }],
          gender: [{ required: true, message: '请选择性别', trigger: 'change' }]
        },
        // 被保人修改表单字段项配置
        editItems: [
          {
            // 被保人基础信息部分
            type: 'insured',
            title: '被保人信息',
            items: [
              { label: '批单生效日', key: 'batchDate', type: 'date', disabledDate: this.batchDateDisDate, writeable: true, deviceType: 'p', required: true },
              { label: '是否主被保人', key: 'batchInsuredExt.isMain', type: 'select', writeable: true, required: false, dataSource: commonOptions.yesNoOptions, changeFn: this.changeInsured },
              { label: '主被保人姓名', key: 'batchInsuredExt.mainName', writeable: false, required: false },
              { label: '被保人姓名', key: 'name', writeable: true, required: true, blurFn: this.changeInsured },
              { label: '手机号', key: 'mobile', writeable: true, blurFn: this.changeInsured },
              { label: '证件类型', key: 'idType', type: 'select', writeable: true, required: true, dataSource: commonOptions.idTypeOps, changeFn: this.changeInsured },
              { label: '证件号码', key: 'idNumber', writeable: true, required: true, blurFn: this.changeInsured },
              { label: '出生日期', key: 'birthDate', type: 'date', disabledDate: this.birthdateDisDate, writeable: true, required: true, changeFn: this.changeInsured },
              { label: '性别', key: 'gender', type: 'select', writeable: true, required: true, dataSource: commonOptions.sexOptions, changeFn: this.changeInsured },
              { label: '批单生效', key: 'batchDate', type: 'date', writeable: true, required: true, disabledDate: this.batchDateDisDate, changeFn: this.changeInsured, deviceType: 'm' },
              { label: '保费', key: 'premium', required: true, deviceType: 'm' },
              { label: '批改类型', key: 'correctType', required: false, deviceType: 'm' }
            ]
          }
        ],
        // 表格渲染函数配置
        tableRender: {}
      }
    };
  },
  created() {},
  methods: {
    // 被保人信息字段修改
    privateChangeInsured(value, type, index) {
      let flag = false;
      // 如果是 是否主被保人 变更
      if (type === 'batchInsuredExt.isMain') {
        flag = this.isMainChange(value, index);
      } else if (type === 'name') {
        flag = this.nameChange(value, index);
      }
      return flag;
    }
  }
};
</script>

<style lang="scss">
@import '../assets/css/index.scss';
</style>
